template = require('./dropdown.html.slim')

angular.module('wbComponents').directive 'wbDropdown', ['toggle', (toggle) ->
  scope: true
  restrict: 'E'
  transclude: true
  replace: true
  templateUrl: template
  scope:
    label: '@'

  link: ($scope, $el, $attrs) ->
    $attrs.$observe 'disabled', (disabled) -> $scope.disabled = disabled?
    toggle.register($scope)
    $scope.toggle = (e) ->
      e.preventDefault()
      e.stopPropagation()
      toggle.toggle($scope)
]
